module.exports = __webpack_public_path__ + "static/media/hearts_7.72e8a8b8.png";